import { render } from "./globalTutor.vue?vue&type=template&id=f00340d6&scoped=true"
import script from "./globalTutor.vue?vue&type=script&lang=js"
export * from "./globalTutor.vue?vue&type=script&lang=js"

import "./globalTutor.vue?vue&type=style&index=0&id=f00340d6&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Stage-integrated-sugang-admin-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f00340d6"]])

export default __exports__